export default {
    login_register: 'Pieteikties/Reģistrēties',
    booking_confirmation_title: 'Rezervācijas apstiprinājums',
    booking_confirmation_body: 'Paldies par jūsu rezervāciju. Apstiprinājuma detaļas skatiet zemāk.',
    insurance_requirements_modal_disclaimer: `Veicot šo rezervāciju, es apliecinu, ka: pēdējo 5 gadu laikā man nav bijuši notiesājoši spriedumi vai ceļu satiksmes pārkāpumi. Man nav atteikts apdrošināšanas piedāvājums, atcelta polise vai atteikta atjaunošana, kā arī nav noteikta paaugstināta prēmija vai īpaši nosacījumi nevienā apdrošināšanas sabiedrībā. Man nav atņemtas tiesības vadīt transportlīdzekli. Man nav uzsākta kriminālvajāšana vai policijas izmeklēšana. Pēdējo 5 gadu laikā man nav notiesājošu spriedumu par zādzību, krāpšanu vai negodīgumu. Man nav redzes vai dzirdes traucējumu (ko nevar koriģēt ar brillēm vai dzirdes aparātu), sirds slimību, diabēta, krampju vai jebkādu fizisku vai garīgu traucējumu. Pēdējo 5 gadu laikā man nav bijis neviena negadījuma. Ja neatbilstat šīm prasībām, lūdzu, spiediet {0}`,
    insurance_requirements_here: 'šeit',
    insurance_requirements: 'Esmu izlasījis un sapratis {0}',
    ir: 'Apdrošināšanas prasības',
    location: 'Atrašanās vieta',
    pickup_location: 'Saņemšanas vieta',
    dropoff_location: 'Atdošanas vieta',
    vehicle: 'Transportlīdzeklis',
    pickup_and_dropoff: 'Saņemšana un atdošana (pēc vietējā laika)',
    view_voucher: 'Skatīt vaučeru',
    identity_verification_body: 'Pirms transportlīdzekļa saņemšanas būs jāapstiprina jūsu identitāte',
    identity_verification_title: 'Identitātes apstiprināšana',
    search_again: 'Meklēt vēlreiz',
    refrigerated: 'atdzesēts',
    aircon_lower: 'kondicionieris',
    aircon: 'Kondicionieris',
    refrigeration: 'Atdzesēts',
    not_available: 'Drive & Go šobrīd pieejams tikai personām ar identitātes un vadītāja apliecības dokumentiem no šīm valstīm.',
    check_if_included: 'Pārbaudiet, vai jūsu valsts ir iekļauta.',
    included_in_booking: 'Iekļauts šajā rezervācijā',
    cdw_with_excess: 'CDW ar pašrisku',
    theft_protection: 'Zādzības aizsardzība ar pašrisku',
    risk_reduction: 'Riska samazināšana',
    free_extras: 'Šai rezervācijai pienākas divi bezmaksas papildinājumi <br />.',
    continue: 'Turpināt',
    luggage_large_short_label: 'L',
    luggage_medium_short_label: 'M',
    luggage_small_short_label: 'S',
    luggage_large_long_label: 'liels',
    luggage_medium_long_label: 'vidējs',
    luggage_small_long_label: 'mazs',
    fuel_unspecified_label: 'nav norādīts',
    transmission_manual_label: 'Manuāla',
    transmission_automatic_label: 'Automātiska',
    make_a_booking: 'Veikt rezervāciju',
    pickup_date: 'Saņemšanas datums',
    dropoff_date: 'Atdošanas datums',
    driver_age: 'Vadītājs vecumā no 30 līdz 65',
    enter_driver_age: 'Lūdzu, ievadiet vadītāja vecumu',
    promo_code: 'Atlaižu kods',
    search: 'Meklēt',
    dropoff_date_cannot_be_before_pickup_date: 'Atdošanas datums nevar būt pirms saņemšanas datuma',
    pickup_date_cannot_be_in_the_past: 'Saņemšanas datums nevar būt pagātnē',
    pickup_time_cannot_be_in_the_past: 'Saņemšanas laiks nevar būt pagātnē',
    dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'Atdošanas laikam jābūt vēlākam par saņemšanas laiku, ja tas ir tajā pašā dienā',
    vehicle_filters: 'Transportlīdzekļu filtri',
    reset: 'Atiestatīt',
    transmission: 'Pārnesumkārba',
    all: 'Visi',
    manual: 'Manuāla',
    auto: 'Automātiska',
    passengers: 'Pasažieri',
    vehicle_type: 'Transportlīdzekļa tips',
    filter: 'Filtrēt',
    vehicle_search: 'Transportlīdzekļu meklēšana',
    edit: 'Rediģēt',
    no_results: 'Nav rezultātu atbilstoši jūsu filtriem.',
    small_cars: 'Mazie auto',
    medium_cars: 'Vidējie auto',
    large_cars: 'Lielie auto',
    estate_cars: 'Universāļi',
    suvs: 'SUV',
    mpvs: 'Vienapjoma auto',
    vans: 'Furgoni',
    camper_vans: 'Kemperi',
    premium: 'Premium',
    unspecified: 'nav norādīts',
    large: 'liels',
    medium: 'vidējs',
    small: 'mazs',
    automatic: 'automātiska',
    you_have_been_refunded: 'Jums ir veikta naudas atmaksa.',
    please_customer_service: 'Lai veiktu rezervāciju, lūdzu, sazinieties ar mūsu klientu apkalpošanas dienestu.',
    contact_customer_service: 'Sazināties ar klientu apkalpošanu',
    booking_failed: 'Šoreiz rezervāciju neizdevās apstrādāt.',
    summary: 'Kopsavilkums',
    reforestation_and_protection: 'Atbalstiet lietusmežu atjaunošanu un aizsardzību visā Kostarikā',
    cost_of_rental: 'Nomaišanas izmaksas',
    to_pay_now: 'Jāmaksā tagad',
    greenheart_donation: 'Green Heart ziedojums',
    total_cost: 'Kopējās nomas izmaksas',
    tc_agreement: 'Esmu izlasījis un sapratis {0}.',
    tc: 'Noteikumi un nosacījumi',
    receive_offers: 'Vēlos saņemt īpašos piedāvājumus e-pastā.',
    donate: 'Jā, vēlos ziedot {amount}',
    pay_now: 'Maksāt tagad {amount}',
    driver_details: 'Vadītāja dati',
    complete_driver_details: 'Lūdzu, aizpildiet vadītāja datus.',
    are_you_the_driver: 'Vai jūs esat vadītājs?',
    have_an_account: 'Vai jums jau ir konts?',
    login: 'Pieteikties',
    or: 'vai',
    first_name: 'Vadītāja vārds',
    last_name: 'Vadītāja uzvārds',
    email: 'E-pasta adrese',
    phone_number: 'Mobilā tālruņa numurs',
    unable_to_save_driver_information: 'Neizdevās saglabāt vadītāja informāciju. Lūdzu, mēģiniet vēlreiz.',
    pay_online_now: 'Maksāt tagad',
    day: 'Diena',
    choose_location: 'Izvēlieties vietu',
    location_not_found: 'Atvainojiet, norādīto vietu neizdevās atrast.',
    add: 'Pievienot',
    remove: 'Noņemt',
    free_extra: 'Bezmaksas papildinājums',
    free: 'BEZ MAKSAS!',
    fast_track_notice: 'Šim pakalpojumam ir dokumentu izcelsmes ierobežojumi. Pieejams tikai personām ar dokumentiem no',
    complete_booking: 'Pabeigt rezervāciju',
    choose_card: 'Lūdzu, izvēlieties karti vai pievienojiet jaunu.',
    add_billing_details: 'Lūdzu, pievienojiet norēķinu datus.',
    card_number: 'Kartes numurs',
    card_holder_name: 'Kartes īpašnieka vārds',
    card_exp: 'MM / GG',
    card_cvc: 'CVC',
    save_card: 'Saglabāt karti?',
    amount_charged: 'No jūsu kartes tiks iekasēta maksa',
    payment_confirmation: 'Apstiprināt rezervāciju un maksāt',
    payment_methods: 'pieejamās maksājumu metodes',
    use_saved_card: 'x izmantot saglabāto karti',
    use_different_card: '+ izmantot citu karti',
    book_now: 'Rezervēt tagad',
    minimum_age: 'Tikai vecākiem par {age}',
    excess_liability: 'Pašrisks',
    security_deposit: 'Drošības depozīts',
    fuel_policy: 'Degvielas politika',
    like_for_like: 'Tik, cik bija',
    full_to_full: 'Pilns-pilns',
    miles_per_rental: '{mileage} bezmaksas jūdzes par nomu',
    km_per_rental: '{mileage} bezmaksas km par nomu',
    unlimited_mileage: 'Neierobežots nobraukums',
    unlimited_mileage_km: 'Neierobežoti km',
    non_amendable: 'Nav maināms',
    non_refundable: 'Nav atmaksājams',
    free_cancellation_until: 'Bezmaksas atcelšana līdz',
    cancellation_in_line_with: 'Atcelšana saskaņā ar',
    tcs: 'Noteikumi un nosacījumi',
    free_extras_on_collection: 'Divi bezmaksas papildinājumi saņemot',
    glass_and_tyres_covered: 'Stikls un riepas iekļautas',
    number_of_passengers: 'Pasažieru skaits',
    number_of_bags: 'Bagāžas skaits',
    fuel_type: 'Degvielas veids',
    co2: 'CO2',
    book_type: 'Rezervēt {type}',
    processing: 'Apstrāde',
    actual_price: 'Faktiskā cena',
    tooltip: 'Cena {currencyCode} ir aptuvena pēc valūtas kursa, cena {currency} ir saistoša.',
    deposit: 'Depozīts',
    pay_online: 'Maksāt tagad',
    pay_online_without_extras: 'Nomas cena',
    extras_on_arrival: 'Papildinājumi saņemot',
    insurance_on_arrival: 'Riska samazināšana - maksāt saņemot',
    insurance_online: 'Riska samazināšana - maksāt tagad',
    extras_online: 'Papildinājumi - maksāt tagad',
    green_heart_donation: 'Green Heart ziedojums',
    why_use_drive_and_go: 'Kāpēc izvēlēties Drive & Go?',
    straight_to_car: 'Tieši pie auto',
    no_queues: 'Nav rindas',
    self_checkout: 'Pašapkalpošanās saņemšana',
    cant_lose_key: 'Atslēgu nevar pazaudēt',
    online_id_check: 'Tiešsaistes ID pārbaude',
    phone_as_key: 'Telefons kā atslēga',
    premiumplus_benefits_includes: 'Iekļauti arī Premium Plus+ ieguvumi',
    book_drive_go: 'Rezervēt Drive & Go',
    distance_allowance: 'Atļautais attālums',
    duration: 'Ilgums',
    view_more_bookings: 'Skatīt vairāk rezervāciju',
    to_pay_on_arrival: 'Jāmaksā saņemot',
    pay_on_arrival: 'Maksāt saņemot',
    unlimited: 'Neierobežots',
    return_date: 'Atdošanas datums',
    postcode: 'Pasta indekss',
    country: 'Valsts',
    drive_and_go: {
        drive_and_go: 'Drive And Go',
        available_countries: 'Drive & Go šobrīd pieejams tikai personām ar identitātes un vadītāja apliecības dokumentiem no šīm valstīm:',
        drive_and_go_today: 'Drive & Go rezervācija šodien!',
        drive_and_go_shortened: 'Drive & Go',
        why_use_drive_and_go: 'Kāpēc izvēlēties Drive & Go?',
        straight_to_car: 'Tieši pie auto',
        no_queues: 'Nav rindas',
        self_checkout: 'Pašapkalpošanās saņemšana',
        cannot_lose_the_key: 'Atslēgu nevar pazaudēt',
        online_id_check: 'Tiešsaistes ID pārbaude',
        phone_as_a_key: 'Telefons kā atslēga',
        premium_plus_benefits_also_included: 'Iekļauti arī Premium Plus+ ieguvumi',
        book_drive_and_go: 'Rezervēt Drive & Go',
    },
    car_and_camp: {
        tent_and_equipment: 'Telts un aprīkojums',
        quick_and_easy: 'Ātri un viegli uzstādāma',
        travel_freedom: 'Ceļošanas brīvība',
        affordable_campervan_alternative: 'Pieejama kempinga furgona alternatīva',
        lightweight_and_compact: 'Viegla un kompakta',
        fully_insured: 'Pilnībā apdrošināta',
    },
    my_bookings: 'Mana rezervācija',
    no_bookings: 'Nav rezervāciju',
    my_profile: 'Mans profils',
    no_bookings_to_display: 'Nav rezervāciju, ko parādīt.',
    search_great_car_rental_deals: 'Meklējiet lieliskus auto nomas piedāvājumus savam nākamajam ceļojumam.',
    odometer_at_collection: 'Odometrs saņemot',
    fuel_at_collection: 'Degviela saņemot',
    start_check_in: 'Sākt reģistrāciju',
    start_collection: 'Sākt saņemšanu',
    recent_bookings: 'Nesenā rezervācija',
    damage: {
        updated_damage_report_submitted: 'Iesniegts atjaunināts bojājumu ziņojums. Ja nepieciešams, ar jums sazināsies mūsu klientu apkalpošanas komanda.',
        add_additional_damage: 'Pievienot papildu bojājumu',
        you_may_report_additional_damage_up_to: 'Papildu bojājumus varat ziņot līdz 24 stundām pēc auto atdošanas',
        specify_damage: 'Norādiet bojājumu',
        please_choose_the_area_and_type_of_damage: 'Lūdzu, izvēlieties bojājuma vietu un veidu',
        type_of_damage: 'Bojājuma veids',
        is_this_more_than_5_cm: 'Vai tas ir vairāk nekā 5 cm?',
        please_take_or_select_a_photo: 'Lūdzu, uzņemiet vai izvēlieties fotoattēlu',
        please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Lūdzu, uzņemiet fotoattēlu, lai bojājums būtu skaidri redzams',
        if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' Ja nepieciešams, varat pievienot vēl vienu fotoattēlu, izvēlieties ikonu',
        save_image: 'Saglabāt attēlu',
        save_images: 'Saglabāt attēlus',
        damage_saved_successfully: 'Bojājums veiksmīgi saglabāts',
        add_photo: 'Pievienot foto',
    },
    checkout: {
        start_collection: 'Sākt saņemšanu',
        collect_vehicle: 'Saņemt auto',
        we_will_let_you_know_the_details: 'Informēsim jūs par atrašanās vietu un detaļām, lai varētu atrast nomas auto.',
        inspect: 'Apskatīt',
        we_will_ask_for_four_photos_from_each_corner: 'Lūgsim četras fotogrāfijas no katra auto stūra, kā arī visus jaunus bojājumus, kas vēl nav uzskaitīti.',
        fuel_and_milage: 'Degviela un nobraukums',
        you_confirm_the_readings_at_the_start_of_your_hire: 'Jūs apstiprināt odometra un degvielas rādījumus nomas sākumā.',
        sign: 'Parakstīt',
        sign_the_rental_agreement: 'Parakstīt nomas līgumu.',
        away_you_go: 'Lai jums laba ceļojuma!',
        you_are_free_to_take_to_the_road: 'Varat doties ceļā!',
        collect_your_vehicle: 'Saņemiet savu auto',
        get_directions: 'Saņemt norādes',
        hide_directions: 'Slēpt norādes',
        local_time: 'vietējais laiks',
        tel: 'Tālrunis',
        getting_to_the_location: 'Kā nokļūt vietā',
        get_vehicle_details: 'Saņemt auto detaļas',
        view_map: 'Skatīt karti',
        unlock_vehicle_and_continue: 'Atbloķēt auto un turpināt',
        unable_to_connect_to_vehicle: 'Neizdevās izveidot savienojumu ar auto',
        we_were_unable_to_connect_to_the_vehicle_please_check: 'Neizdevās izveidot savienojumu ar auto – pārbaudiet, vai atrodaties pie pareizā auto, un mēģiniet vēlreiz.',
        we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Neizdevās atrast auto rezervāciju. Lūdzu, mēģiniet vēlāk.',
        odometer_and_fuel: 'Odometrs un degviela',
        odometer: 'Odometrs',
        please_confirm_the_odometer_and_fuel_readings: 'Ja iespējams, apstipriniet odometra un degvielas rādījumus.',
        the_odometer_field_is_required: 'Odometrs ir obligāts lauks',
        and_must_be_greater_than_the_checkout_odometer: 'un jābūt lielākam nekā saņemot',
        confirm: 'Apstiprināt',
        please_take_a_photo_from_each_corner_of_the_vehicle: 'Lūdzu, uzņemiet foto no katra auto stūra',
        pre_existing_damage: 'Esošie bojājumi',
        no_pre_existing_damage: 'Nav esošu bojājumu.',
        new_damage: 'Jauns bojājums',
        add_additional_damage: 'pievienot papildu bojājumu',
        no_new_damage_to_report: 'Nav jaunu bojājumu',
        checkout_complete: 'Saņemšana pabeigta',
        start_rental: 'Sākt nomu',
        congratulations_name_it_is_time_to_take_to_the_road: 'Apsveicam, {customer_name}, ir laiks doties ceļā!',
        we_are_unable_to_complete_your_vehicle_checkout: 'Neizdevās pabeigt auto saņemšanu.',
        please_do_the_following: 'Lūdzu, veiciet sekojošo',
        remove_all_belonging_and_lock_the_vehicle: 'Izņemiet visas mantas un aizslēdziet auto.',
        lock_vehicle: 'Aizslēgt auto',
        once_you_have_contacted_customer_services: 'Kad būsiet sazinājies ar klientu apkalpošanu',
        vehicle_location: 'Auto atrašanās vieta',
        collect_your: 'Saņemiet savu',
        from: 'No',
        key_in_glove_box: 'atslēga atrodas cimdu nodalījumā',

        keyholder: {
            not_detected: 'Atslēga nav atrasta turētājā',
            not_detected_please_try_again: 'Ievietojiet atslēgu turētājā un mēģiniet vēlreiz.',

            not_installed: 'Atslēgu turētājs nav uzstādīts',
            not_installed_please_contact_customer_service: 'Atslēgu turētājs nav uzstādīts, lūdzu, sazinieties ar klientu apkalpošanu.',
        },
        keyring: {
            look_up_failed: 'Atslēgu turētāja meklēšana neizdevās',
            look_up_failed_please_contact_customer_service: 'Atslēgu turētāja meklēšana neizdevās, lūdzu, sazinieties ar klientu apkalpošanu.',
        },
        key: {
            invalid: 'Atslēga nav derīga',
            invalid_please_contact_customer_service: 'Jūsu atslēga nav derīga, lūdzu, sazinieties ar klientu apkalpošanu.',

            expired: 'Atslēga ir beigusies',
            expired__please_contact_customer_service: 'Jūsu atslēgas derīguma termiņš ir beidzies, lūdzu, sazinieties ar klientu apkalpošanu.',
        },
    },
    checkin: {
        start_check_in: 'Sākt reģistrāciju',
        vehicle_location: 'Auto atrašanās vieta',
        tell_us_where_you_have_parked: 'Pastāstiet, kur esat novietojis auto.',
        fuel_and_milage: 'Degviela un nobraukums',
        you_confirm_the_readings_at_the_end_of_your_hire: 'Jūs apstiprināt odometra un degvielas rādījumus nomas beigās.',
        inspect: 'Apskatīt',
        we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage:
            'Lūgsim četras fotogrāfijas no katra auto stūra, kā arī visus jaunus bojājumus, kas radušies nomas laikā.',
        lock: 'Aizslēgt',
        check_you_have_left_no_belonging_then_lock_the_vehicle: 'Pārliecinieties, ka nav atstātu mantu, un aizslēdziet auto.',
        please_tell_us_where_you_have_parked_the_vehicle: 'Pastāstiet, kur esat novietojis auto',
        once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Kad auto būs aizslēgts, to vairs nevarēs atslēgt.',
        name_please_check_you_have_left_no_belongings_then_lock_the_vehicle:
            '{first_name}, pārliecinieties, ka nav atstātu mantu, aizslēdziet auto un, ja nepieciešams, atgrieziet fizisko atslēgu turētājā.',
        lock_vehicle: 'Aizslēgt auto',
        complete_check_in: 'Pabeigt reģistrāciju',
        inspection: 'Apskate',
        complete_vehicle_check_in: 'Pabeigt auto reģistrāciju',
        we_are_unable_to_complete_your_vehicle_check_in: 'Neizdevās pabeigt auto reģistrāciju.',
        please_contact_customer_services: 'Lūdzu, sazinieties ar klientu apkalpošanu',
        once_you_have_contacted_customer_services: 'Kad būsiet sazinājies ar klientu apkalpošanu',
        please_amend_odometer_to_be_greater_than: 'Lūdzu, mainiet odometra rādījumu uz lielāku par {odometer_value}',
    },
    rental_agreement: {
        rental_agreement: 'Nomas līgums',
        agreement_between: 'Līgums starp',
        and: 'un',
        sign_rental_agreement: 'Parakstīt nomas līgumu',
        i_have_read_and_understood_the_terms_and_conditions: 'Esmu izlasījis un sapratis noteikumus un piekrītu auto stāvoklim',
    },
    additional_options: 'Papildu iespējas',
    booking_details: 'Rezervācijas detaļas',
    price_for_x_days: 'Cena par {qty_of_days} dienu | Cena par {qty_of_days} dienām',
    cancelled: 'Atcelts',
    upcoming: 'Drīzumā',
    active: 'Aktīvs',
    full_insurance_no_deposit: 'Pilna apdrošināšana un nav nepieciešams depozīts',
    excess: '{amount} pašrisks',
    deposit: '{amount} depozīts',
    included_daily_distance: '{distance} {unit} dienā',
    miles: 'jūdzes',
    kilometers: 'kilometri',
    collection_details_title: 'Saņemšanas detaļas',
    collection_details_not_found: 'Šai vietai nav definētas saņemšanas detaļas',
    free_cancellation: 'Bezmaksas atcelšana',
    no_deposit: 'Bez depozīta',
    benefit_from: 'Izmantojiet',
    for_only_per_day: 'Tikai par {price} dienā',
    upgrade_mee: 'UpgradeMee',
};
